import React, { useState, useRef, useCallback, useContext } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import { LoginOauth } from '../login-oauth/LoginOauth';
import Button, { ButtonTypes } from 'devextreme-react/button';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import notify from 'devextreme/ui/notify';

import { useAuth } from '../../../contexts/auth';
import { ThemeContext } from '../../../theme/theme';

import './LoginForm.scss';

function getButtonStylingMode(
  theme: string | undefined
): ButtonTypes.ButtonStyle {
  return theme === 'dark' ? 'outlined' : 'contained';
}

export const LoginForm = ({ resetLink, createAccountLink }) => {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [loading, setLoading] = useState(false);
  const formData = useRef({ username: '', password: '' });
  const themeContext = useContext(ThemeContext);
  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { username, password } = formData.current;
      setLoading(true);

      const result = await signIn(username, password);
      console.log('LOGIN RESULT:', result);
      if (result.isOk && result.user) {
        // localStorage.setItem('userId', result.user.ID.toString());
        // localStorage.setItem('userName', result.user.USER_NAME);
        // localStorage.setItem('fullname', result.user.FULL_NAME);
        // localStorage.setItem("cap", result.user.CAP);
        navigate('/bao-cao-tuan-tra');
      } else {
        setLoading(false);
        notify(result.message, 'error', 2000);
      }
    },
    [signIn]
  );
  const onCreateAccountClick = useCallback(() => {
    navigate(createAccountLink);
  }, [navigate]);

  return (
    <form className='login-form' onSubmit={onSubmit}>
      <Form
        labelLocation='top'
        formData={formData.current}
        disabled={loading}
        showColonAfterLabel
      >
        <Item
          dataField='username'
          editorType='dxTextBox'
          editorOptions={{
            inputAttr: {
              style: 'font-size:16px',
            },
          }}
        >
          <RequiredRule message='Nhập tài khoản' />
          {/* <EmailRule message='User is invalid' /> */}
          <Label text='Tên tài khoản' />
        </Item>
        <Item
          dataField='password'
          editorType='dxTextBox'
          // editorOptions={{ mode: 'password' }}
          editorOptions={{
            mode: 'password',
            inputAttr: {
              style: 'font-size:16px',
            },
          }}
        >
          <RequiredRule message='Nhập mật khẩu' />
          <Label text='Mật khẩu' />
        </Item>
        {/* <Item dataField='rememberMe' editorType='dxCheckBox' editorOptions={rememberMeEditorOptions}>
          <Label visible={false} />
        </Item> */}
        <ButtonItem>
          <ButtonOptions width='100%' type='default' useSubmitBehavior>
            <span className='dx-button-text'>
              {loading ? (
                <LoadIndicator width='24px' height='24px' visible />
              ) : (
                'Đăng nhập'
              )}
            </span>
          </ButtonOptions>
        </ButtonItem>
      </Form>
      {/* <div className='reset-link'>
        <Link to={resetLink}>Forgot password?</Link>
      </div> */}

      {/* <Button
        className='btn-create-account'
        text='Register'
        width='100%'
        onClick={onCreateAccountClick}
        stylingMode={getButtonStylingMode(themeContext?.theme)}
      /> */}

      {/* <LoginOauth /> */}
    </form>
  );
};

// const emailEditorOptions = { stylingMode: 'filled', mode: 'email', value: 'jheart@dx-email.com' };
// const passwordEditorOptions = { stylingMode: 'filled', mode: 'password', value: 'password' };
// const rememberMeEditorOptions = { text: 'Remember me', elementAttr: { class: 'form-text' } };
